import React from 'react'
import {BsLinkedin} from 'react-icons/bs'
import {BsGithub} from 'react-icons/bs'
import {BsTwitter} from 'react-icons/bs'
import {BsInstagram} from 'react-icons/bs'


const HeaderSocials = () => {
  return (
    <div className='header__socials'>
        <a href="https://www.linkedin.com/in/enes-aydo%C4%9Fdu-aa32091ba/" target="_blank"><BsLinkedin /></a>
        <a href="https://github.com/ayd0gdu" target="_blank"><BsGithub /></a>
        <a href="https://twitter.com/_aydogduenes" target="_blank"><BsTwitter /></a>
        <a href="https://www.instagram.com/ayd0gdu_/" target="_blank"><BsInstagram /></a>
    </div>
  )
}

export default HeaderSocials